import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuthFetch } from "../../../utils/useAuthFetch";
import { useWorkspaceContext } from "../../../providers/WorkspaceProvider";
import { createViewService } from "../services/viewService";

/** Every page belongs to one workspace, canvas element and selected source row. */
export function useRelatedRecords(
  canvasId: string | null,
  elementId: string,
  rowId: string | null,
) {
  const { workspace } = useWorkspaceContext();
  const workspaceId = workspace?.id || "";
  const authFetch = useAuthFetch();
  const key = JSON.stringify([workspaceId, canvasId, elementId, rowId]);
  const [paging, setPaging] = useState({ key, page: 1 });
  const page = paging.key === key ? paging.page : 1;
  const query = useQuery({
    queryKey: ["relatedRecords", workspaceId, canvasId, elementId, rowId, page],
    queryFn: () =>
      createViewService(authFetch, workspaceId).queryRelatedRecords(
        canvasId!,
        elementId,
        rowId!,
        page,
      ),
    enabled: Boolean(workspaceId && canvasId && rowId),
    refetchOnWindowFocus: false,
  });
  return {
    ...query,
    data: rowId && canvasId ? query.data : undefined,
    page,
    setPage: (next: number) => setPaging({ key, page: Math.max(1, next) }),
  };
}
